export const specialCharsRegex = /[`!@#$%^&*()_\-+=[\]{};':"|,.<>?~ ]/;
export const oneNumberRegex = /\d/;
export const oneLetterRegex = /[a-zA-Z]/;
